import { describeBundleRelevanceStatus } from "./bundleRelevanceStatusPresentation";
import { renderRelevanceStatusIcon } from "./relevanceStatusIcon";
import type { BundleRelevanceStatus } from "./useBundleRelevanceStatusesForEncounter";

interface RelevanceStatusExplanationProps {
  status: Exclude<BundleRelevanceStatus, { kind: "pending-review" | "reviewed" }>;
}

export function RelevanceStatusExplanation({ status }: RelevanceStatusExplanationProps) {
  const { label, icon, tooltip, colorClass } = describeBundleRelevanceStatus(status);

  return (
    <div className="flex items-start gap-2 rounded-md border p-3 text-sm">
      {renderRelevanceStatusIcon(icon, colorClass, { iconClassName: "h-3.5 w-3.5" })}
      <div>
        <div className="font-medium">{label}</div>
        <div className="text-muted-foreground">{tooltip}</div>
      </div>
    </div>
  );
}
